import { render, staticRenderFns } from "./CombinationIndex.vue?vue&type=template&id=3181db18&scoped=true&"
import script from "./CombinationIndex.vue?vue&type=script&lang=js&"
export * from "./CombinationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3181db18",
  null
  
)

export default component.exports